const modules = import.meta.glob<{ default: Record<string, unknown> }>('./*/*.ts', { eager: true });

const messages: Record<string, { translation: Record<string, unknown> }> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang, namespace] = match;

    if (!messages[lang]) {
      messages[lang] = { translation: {} };
    }

    const module = modules[path];

    if (module.default) {
      messages[lang].translation[namespace] = module.default;
    }
  }
});

export default messages;